import { node } from 'prop-types';
import { createContext, useEffect, useMemo, useContext, useState } from 'react';
import useProfile from '../../data/useProfile';
import useCampaignData from '../../data/useCampaignData';
import useConfigEnv from '../../data/useConfigEnv';

const AnalyticsContext = createContext();

const AnalyticsProvider = ({ children }) => {
	const {
		data: { id, status },
	} = useProfile();

	const [analyticsRef, setAnalyticsRef] = useState({
		logEvent: () => {},
		setUserProperties: () => {},
	});
	const [statusInit] = useState(status);

	const {
		data: {
			globalTimer,
			freeNavigation,
			mobileMode,
			hasVideoAnswers,
			campaignId,
			clientId,
			product,
			locale,
			proctoring: { randomPictures },
		},
	} = useCampaignData();

	const userProperties = useMemo(
		() => ({
			ProctoringActivated: randomPictures,
			CandidateType: product,
			TimerActivated: globalTimer,
			BackActivated: freeNavigation,
			CampaignId: campaignId,
			Origin: statusInit,
			ClientID: clientId,
			ResponsiveActivated: mobileMode,
			VideoAnswerActivated: hasVideoAnswers,
			Language: locale,
		}),
		[
			campaignId,
			clientId,
			freeNavigation,
			globalTimer,
			hasVideoAnswers,
			locale,
			mobileMode,
			product,
			randomPictures,
			statusInit,
		]
	);

	const {
		data: {
			ENVARS: { ANALYTICS_TOKEN },
		},
	} = useConfigEnv();

	useEffect(() => {
		(async function initialize() {
			if (ANALYTICS_TOKEN) {
				const analytics = (await import(/* webpackChunkName: "amplitude" */ 'amplitude-js'))
					.default;

				analytics.getInstance().init(ANALYTICS_TOKEN, id);
				analytics.setUserProperties(userProperties);
				setAnalyticsRef(analytics);
			}
		})();
	}, [ANALYTICS_TOKEN, id, userProperties]);

	return <AnalyticsContext.Provider value={analyticsRef}>{children}</AnalyticsContext.Provider>;
};

/**
 *
 * @return {{logEvent:Function}}
 */
export const useSendAnalytics = () => useContext(AnalyticsContext);

export default AnalyticsProvider;

AnalyticsProvider.propTypes = {
	children: node,
};
